import { CALL_API, REQUEST_GET, REQUEST_POST } from '../middleware/api'
import { NONE, REPORT } from '../schemas/index'
import { SUCCESS } from '../components/AlertListItem'
import uniq from 'lodash/uniq'
import { buildBaseURL } from '../utils/urlHelper'

export const ADD_REPORT_TO_WORKSPACE_REQUEST = 'ADD_REPORT_TO_WORKSPACE_REQUEST'
export const ADD_REPORT_TO_WORKSPACE_SUCCESS = 'ADD_REPORT_TO_WORKSPACE_SUCCESS'
export const ADD_REPORT_TO_WORKSPACE_FAILURE = 'ADD_REPORT_TO_WORKSPACE_FAILURE'
export const REPORT_REQUEST = 'REPORT_REQUEST'
export const REPORT_SUCCESS = 'REPORT_SUCCESS'
export const REPORT_FAILURE = 'REPORT_FAILURE'

export function fetchReport(company, id) {
  return {
    [CALL_API]: {
      types: [REPORT_REQUEST, REPORT_SUCCESS, REPORT_FAILURE],
      endpoint: `companies/${company.id}/reports/${id}.json`,
      requestType: REQUEST_GET,
      schema: REPORT
    }
  }
}

export function addReportToWorkspace(company, report, workspace) {
  const workspaceURL = buildBaseURL(`workspaces/${workspace.id}`)
  return {
    [ADD_REPORT_TO_WORKSPACE_SUCCESS]: {
      entities: {
        reports: {
          [report.id]: {
            workspaces: uniq([...report.workspaces, workspace.id])
          }
        }
      },
      alert: {
        type: SUCCESS,
        message: `Added to ${workspace.name}. <a href="${workspaceURL}">View it now!</a>`,
        htmlSafe: true
      }
    },
    [CALL_API]: {
      types: [
        ADD_REPORT_TO_WORKSPACE_REQUEST,
        ADD_REPORT_TO_WORKSPACE_SUCCESS,
        ADD_REPORT_TO_WORKSPACE_FAILURE
      ],
      endpoint: `companies/${company.id}/workspaces/${workspace.id}/reports/${report.id}.json`,
      requestType: REQUEST_POST,
      schema: NONE
    }
  }
}



// WEBPACK FOOTER //
// ../src/actions/reportActions.js